<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="headerIcon()"
	[headerText]="headerTextToken() | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<div dialogContent>
		@if (isEditable()) {
			<sim-autocomplete
				[dataType]="FetchDataType.SimUser"
				[labelToken]="T.TRAINING_SESSION_PARTICIPANT_LIST_ADD_PARTICIPANTS"
				[excludeIds]="userIds()"
				(onSelect)="addUser($event)"
			/>
		}
		<div class="participantList">
			@if (users()?.length) {
				<div class="scrollViewport">
					@for (user of users(); track user.id) {
						<sim-user-list-item
							(onDelete)="removeUser(user)"
							[user]="user"
							[deletable]="isEditable()"
							[@zoomInOnEnter]
							[@zoomOutOnLeave]
						/>
					}
				</div>
			} @else {
				<div class="emptyState">
					<mat-icon fontIcon="fa-users-slash" fontSet="fad" />
					<label>
						{{ (T.TRAINING_SESSION_PARTICIPANT_LIST_NO_PARTICIPANTS_ADDED | translate).toUpperCase() }}
					</label>
				</div>
			}
		</div>
	</div>

	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontSet: 'fad', fontIcon: 'fa-check'}" [label]="T.BUTTON_OK" [color]="'accent'" />
	</ng-container>
</sim-basic-material-dialog>
